/**
 * Encodes a parameter string using base64 encoding
 * @param params - The parameter string to encode
 * @returns The encoded string
 */
export function encodeParameters(params: string): string {
  return btoa(params);
}

/**
 * Decodes a parameter string from base64 encoding
 * @param encodedParams - The encoded parameter string
 * @returns The decoded parameter string
 */
export function decodeParameters(encodedParams: string): string {
  try {
    return atob(encodedParams);
  } catch (error) {
    console.error("Failed to decode parameters:", error);
    return "";
  }
}
